module.exports = __webpack_public_path__ + "img/gs_lc.3e217af.png";